export const socialLinks = {
  telegramChannel: 'https://t.me/polynetica',
  twitter: 'https://x.com/polynetica',
  youtube: 'https://www.youtube.com/@Polynetica',
  discord: 'https://discord.gg/vGACpaWbEw',
  galxe: 'https://app.galxe.com/quest/polynetica/GCAqFto46n',
  reddit: 'https://www.reddit.com/r/POLLY/',
};
